/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { Grid, Button, Typography, Loading } from "../core";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
// import Delete from "../components/DeleteModal";
import { PlusOutlined } from "@ant-design/icons";
import { Avatar, Row } from "antd";
import { MixStyle } from "../styles";
import { UserOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { clearState } from "../redux/Action/company";

import { Menu, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { deleteCompany } from "../redux/Action/company";

import { getCompany } from "../redux/Action/company";
import DeleteModals from "../components/Modals/deleteModals";
import AddCompany from "../components/Modals/Comapny/addCompanyModal";
const Notify_Utils = require("../helper/utils/Notification");

const createBtnProps = {
  btnProps: {
    width: "300px",
    margin: "0px 0px 0px auto",
    height: "60px",
    radius: "0px",
    bg: "rgba(255, 255, 255, 0.2)",
  },
  typoProps: {
    align: "center",
    weight: "400",
    color: "white",
    as: "h4",
  },
};

const Container = styled.div`
  background: #233b67;
  min-height: 100vh;
  .ant-dropdown-link {
    font-size: 26px;
    font-weight: bold;
    color: white;
  }
`;

const Wraper = styled.div`
  padding: 20px 0px;
  height: 100%;
  .wraper--box {
    background: rgba(255, 255, 255, 0.2);
    padding: 10px;
    /* cursor: pointer; */
    min-width: 250px;
    margin: 10px;
    ${MixStyle.flexCenter};
    flex-direction: column;
    width: fit-content;
    height: fit-content;
    .flex-between {
      ${MixStyle.flexCenter};
    }
  }
`;

const StyledButton = styled(Button)`
  svg {
    margin: 0px 10px;
  }
`;

const Comapny = () => {
  const [recordToDelete, setRecordTodelete] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState({
    delteConfirmModal: false,
    addCompanyModal: false,
  });
  const [companies, setCompanies] = useState([]);
  let { userDetail } = useSelector((state) => state.auth);

  const dispatchtoAction = useDispatch();
  let history = useHistory();
  let comapnyReduxState = useSelector((state) => state.comapny);

  useEffect(() => {
    console.log("comapnyReduxState.companies", comapnyReduxState.companies);
    if (comapnyReduxState.getCompaniesSuccessfull) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "success",
        comapnyReduxState.getCompaniesSuccessfull
      );
      setCompanies(comapnyReduxState.companies);
      dispatchtoAction(clearState());
    }
    if (comapnyReduxState.getCompaniesFail) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        comapnyReduxState.getCompaniesFail
      );
      dispatchtoAction(clearState());
    }

    if (comapnyReduxState.deleteCompanySuccess) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "success",
        comapnyReduxState.deleteCompanySuccess
      );
      dispatchtoAction(clearState());
      closeModal("deleteConfirmModal");
      getCompanies();
    }
    if (comapnyReduxState.deleteCompanyFail) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        comapnyReduxState.deleteCompanyFail
      );
      dispatchtoAction(clearState());
    }
  }, [comapnyReduxState]);

  useEffect(() => {
    getCompanies();
  }, [userDetail]);

  const getCompanies = () => {
    if (!userDetail?._id) {
      setIsLoading(false);
      return;
    }

    let requestParams = { userId: userDetail._id };
    setIsLoading(true);
    dispatchtoAction(getCompany(requestParams));
  };

  const viewCompanyClickHandler = (params) => {
    localStorage.setItem("companyId", params);
    history.push("/admin");
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
    setRecordTodelete({});
  };

  const companyDeleteHandler = (recordToDelete) => {
    setRecordTodelete(recordToDelete);
    openModal("deleteConfirmModal");
  };

  const confirmDeleteHandler = () => {
    if (recordToDelete) {
      setIsLoading(true);
      let { _id } = recordToDelete;
      dispatchtoAction(deleteCompany(_id));
    }
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => companyDeleteHandler(record)}>
          Delete
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <React.Fragment>
      <div>{isLoading ? <Loading /> : ""}</div>
      <Container>
        <Grid>
          <Wraper>
            <Grid>
              <StyledButton
                {...createBtnProps.btnProps}
                onClick={() => openModal("addCompanyModal")}
              >
                <Typography noMargin {...createBtnProps.typoProps}>
                  <PlusOutlined />
                  Create Company
                </Typography>
              </StyledButton>
              {/* {state.modal_name === "create_company" && (
                <Modal
                  closable={true}
                  visible={state.visible}
                  onCreate={onCreate}
                  okText="Add"
                  maxwidth="568px"
                  footer={false}
                  onOk={oK}
                  onCancel={() => {
                    dispatch({ type: "MODAL_VIEW", payload: false });
                  }}
                  tittle="Create New Company"
                >
                  <CreateForm onCreate={onCreate} form={form} />
                </Modal>
              )} */}
              <Row type="flex" justify="center">
                {companies.map((data, index) => (
                  <div key={data._id || index} className="wraper--box">
                    <Dropdown
                      overlay={() => menu(index, data)}
                      onClick={() => console.log("running click")}
                    >
                      <div
                        style={{ marginLeft: "auto" }}
                        className="ant-dropdown-link cursor-p"
                        onClick={(e) => e.preventDefault()}
                      >
                        <MoreOutlined />
                      </div>
                    </Dropdown>

                    <span
                      className="cursor-p"
                      onClick={() => viewCompanyClickHandler(data._id)}
                    >
                      <Avatar
                        className="d-block m-auto"
                        shape="square"
                        size={64}
                        icon={<UserOutlined />}
                      />
                      <Typography
                        className="mt-10"
                        weight="400"
                        color="white"
                        as="h4"
                      >
                        {data.companyName}
                      </Typography>
                    </span>
                  </div>
                ))}
              </Row>
            </Grid>
          </Wraper>
        </Grid>
      </Container>
      {modalState.addCompanyModal && (
        <AddCompany
          getCompanies={getCompanies}
          addCompanyModalOpen={modalState.addCompanyModal}
          closeModal={closeModal}
        />
      )}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}
    </React.Fragment>
  );
};
export default Comapny;
